import clsx from 'clsx'
import { Link } from 'react-router-dom'

/**
 * The library's primary action. It appears in the masthead and again in the empty
 * state, so it lives here rather than as two copies of the same class string that
 * can drift apart.
 */
export default function NewClassifierButton({ className }: { className?: string }) {
    return (
        <Link
            to="/admin/classifiers/new"
            className={clsx(
                'rounded-lg bg-arwen-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-arwen-700',
                className
            )}
        >
            + New classifier
        </Link>
    )
}
